var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03765 13V6.68267C5.03765 6.13038 5.48536 5.68267 6.03765 5.68267H8.07648C8.62876 5.68267 9.07648 6.13038 9.07648 6.68267V13M5.03765 13L5.0385 10.4537C5.03868 9.90125 4.59091 9.45333 4.0385 9.45333H2C1.44772 9.45333 1 9.90105 1 10.4533V12C1 12.5523 1.44771 13 2 13H5.03765ZM5.03765 13H9.07648M9.07648 13V2C9.07648 1.44772 9.52419 1 10.0765 1H12C12.5523 1 13 1.44772 13 2V12C13 12.5523 12.5523 13 12 13H9.07648Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarActive);
export default __webpack_public_path__ + "static/media/bar-active.ce333c00dd8360a6e9a78886d6d839c9.svg";
export { ForwardRef as ReactComponent };